import React, {Fragment, useState, createRef} from 'react';
import Input from "../form/input";
import Checkbox from "../form/checkbox";
import Title from "../title/title";
import Preloader from "../preloader/preloader";
import File from "../form/file";

const Complete: (props: any) => JSX.Element = (props: any) => {

    const form = createRef<HTMLFormElement>()
    const {summary, buttons, setCompleted} = props;
    const [submitting, setSubmitting] = useState<boolean>(false);

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        setSubmitting(true);

        const formElement = event.currentTarget;
        const formData = new FormData(formElement);

        fetch(`${process.env.REACT_APP_API_URL}/api/configurator/request/submit`, {method: 'POST', redirect: 'follow', body: formData})
            .then(response => response && response.json())
            .then(result => {
                console.log(result);
                setSubmitting(false);
                setCompleted(true);
            })
            .catch(error => console.log('error', error));
    }

    return (
        <Fragment>
            {submitting &&
                <div className="fixed w-full h-full left-0 top-0 z-[1093] bg-white flex flex-row items-center justify-center">
                    <Preloader text="Ihre Anfrage wird gesendet ..." />
                </div>
            }
            <Title title="Fast geschafft" description="Angebot anfordern" hide={true} />
            <div className="mt-8">
                <form ref={form} onSubmit={handleSubmit} >
                    <div className="lg:w-[50%] mb-10">
                        <div className="flex flex-col gap-5">
                            <Input label="Vorname *" name="request[firstName]" required={true} />
                            <Input label="Nachname *" name="request[lastName]" required={true} />
                            <Input label="Adresse *" name="request[address]" required={true} />
                            <div className="flex flex-col lg:grid lg:grid-cols-6 gap-5">
                                <div className="lg:col-span-2">
                                    <Input label="Postleitzahl *" name="request[zip]" required={true} />
                                </div>
                                <div className="lg:col-span-4">
                                    <Input label="Ort *" name="request[city]" required={true} />
                                </div>
                            </div>
                            <Input label="Telefonnummer *" name="request[phone]" required={true} />
                            <Input type="email" label="E-Mail *" name="request[email]" required={true} />
                            <File label="Dateien hochladen" name="files[]" multiple={true} />
                            <Input type="textarea" label="Anmerkung *" name="request[properties][message]" required={true} />
                            <Checkbox label="Ich akzeptiere die Datenschutzerklärung und die Nutzungsbedingungen" required={true} />
                        </div>
                    </div>
                    {summary && summary}
                    {buttons && buttons}
                </form>
            </div>
        </Fragment>
    );
}

export default Complete;
